import $ from 'jquery'
import { saveToLocalStorage, loadFromLocalStorage } from './utils/localStorageUtils'

export function init() {
  $('[data-popover]').each((i, elem) => {
    const $popover = $(elem)
    const id = $(elem).data('popover')
    const localStorageKey = `popoverDismissed___${id}`
    const dismissed = loadFromLocalStorage(localStorageKey)
    if (!dismissed) $popover.removeClass('hide')

    const dismiss = () => {
      $popover.addClass('hide')
      saveToLocalStorage(localStorageKey, true)
    }

    $popover.find('.close-button').on('click', () => dismiss())
    $popover.on('click', (event) => {
      if (event.target === $popover[0]) dismiss()
    })
  })
}
